import { useMountEffect } from "@react-hookz/web";
import React from "react";

import { Container } from "./styles";

type Props = {
  message: string;
  onImpression: () => void;
};

export const GroupSubscriberTooltip: React.FunctionComponent<Props> = ({
  message,
  onImpression,
}) => {
  useMountEffect(() => {
    onImpression();
  });

  return (
    <Container
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  );
};

GroupSubscriberTooltip.displayName = "GroupSubscriberTooltip";
